<template>
  <v-navigation-drawer
    app
    :value="!$vuetify.breakpoint.smAndDown ? true : drawer"
    @input="$emit('drawerValue', $event)"
  >
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="subheading font-weight-regular">
          <img
            src="../assets/bfc-logo-new.png"
            class="pointer"
            alt="bfc"
            router
            @click="$router.push('/')"
          />
          <!-- <img src="../assets/your-institute.png" alt="bfc"> -->
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list dense nav>
      <div class="caption font-weight-medium mt-2 mb-4 text-uppercase ml-3 lg">
        Student Activity
      </div>
      <v-list-item class="mb-2" v-for="item in items" :key="item.title">
        <v-btn
          router
          exact
          :to="isprofileUpdated ? '/' + item.title.toLowerCase() : ''"
          depressed
          class="sn-btn text-capitalize font-weight-regular caption br-50"
        >
          <v-icon small left>{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
      </v-list-item>
    </v-list>

    <v-list dense nav class="mt-2">
      <div class="caption font-weight-medium my-4 text-uppercase ml-3 lg">
        Account
      </div>
      <v-list-item class="mb-2" v-for="item in accItems" :key="item.title">
        <v-btn
          router
          exact
          :to="isprofileUpdated ? '/' + item.title.toLowerCase() : ''"
          depressed
          class="sn-btn text-capitalize font-weight-regular caption br-50"
        >
          <v-icon small left>{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
      </v-list-item>
      <v-list-item>
        <v-btn
          router
          exact
          @click="signOut"
          depressed
          class="sn-btn text-capitalize font-weight-regular caption br-50"
        >
          <v-icon small left>mdi-logout</v-icon>Logout
        </v-btn>
      </v-list-item>
    </v-list>
    <div style="position: absolute; bottom: 0; width:100%">
      <v-layout column class="text-center">
        <div>
          <img style="opacity: .5" src="../assets/rudra.png" alt="Rudranet" />
          <p class="caption grey--text">
            Developed by
            <a class="grey--text" href="https://rudranet.com" target="_blank"
              >Rudranet</a
            >
          </p>
        </div>
      </v-layout>
    </div>
  </v-navigation-drawer>
</template>

<style>
.pointer {
  cursor: pointer;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["drawer"],
  data() {
    return {
      items: [
        { title: "Exercises", icon: "mdi-pencil" },
        { title: "Olympiads", icon: "mdi-trophy-variant" },
        { title: "Scoreboard", icon: "mdi-format-list-bulleted" },
        { title: "Resources", icon: "mdi-file-document" },
      ],
      accItems: [{ title: "Profile", icon: "mdi-account-outline" }],
    };
  },
  methods: {
    ...mapActions(["signOut"]),
  },
  computed: {
    ...mapGetters(["isprofileUpdated"]),
  },
};
</script>

<style>
.br-50 {
  border-radius: 35px !important;
}

.lg {
  color: #bebebe;
}

.sn-btn.v-btn--active {
  background-color: #000 !important;
  color: #fff !important;
}

.sn-btn.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #fff;
}
</style>
